import { render, staticRenderFns } from "./skill-label.vue?vue&type=template&id=37062f40&scoped=true"
import script from "./skill-label.vue?vue&type=script&lang=js"
export * from "./skill-label.vue?vue&type=script&lang=js"
import style0 from "./skill-label.vue?vue&type=style&index=0&id=37062f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37062f40",
  null
  
)

export default component.exports